import React, { useEffect, useState } from 'react';
import { ReactComponent as AgentsIcon } from '../../shared/images/svg/agents2.svg';
import { ReactComponent as LinkForAgentsIcon } from '../../shared/images/svg/linkForAgents.svg';
import { BigCard } from '../../components/BigCard';
import { SearchBar } from '../../components/SearchBar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getAgents } from '../../api/agents';
import { addNotification } from '../../shared/store/slices/notificationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserInitials } from '../../shared/store/slices/nameSlice';

import styles from './styles.module.scss'
import { formatDate } from '../../shared/utils/masks';
import { formatCurrency } from '../../shared/utils/formatCurrency';

const ROW_NUMBER = 50;

export const AgentsPage = () => {
  const [totalAgents, setTotalAgents] = useState(0);
  const [curator, setCurator] = useState({});
  const [agents, setAgents] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [rows, setRows] = useState(ROW_NUMBER);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);

  const dispatch = useDispatch();
  
  const userInitials = useSelector(selectUserInitials);

  const cardsData = [{
    icon: LinkForAgentsIcon,
    label: 'Всего агентов',
    text: totalAgents,
  },{
    icon: AgentsIcon,
    label: 'Мой куратор',
    text: curator?.name || '',
    link: curator?.id,
  },];

  useEffect(() => {
    getAgents()
      .then((data) => {
        setTotalAgents(data.totalAgents);
        setCurator(data.curator);
        setAgents(data.agents.map((agent) => ({...agent, invitedBy: userInitials})));
      })
      .catch((error) => {
        dispatch(addNotification(error.message));
      });
  }, []);

  useEffect(() => {
    setAgents((prevAgents) => prevAgents.map((agent) => ({...agent, invitedBy: userInitials})));
  }, [userInitials]);

  const transformDate = (rowData) => {
    const date = new Date(rowData.date);    
    return formatDate(date);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setRows(ROW_NUMBER);
  };

  const handleScroll = () => {
    const bottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 100;
    
    if (bottom) {
      setRows((prevLimit) => prevLimit + ROW_NUMBER);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleSort = (event) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
    setRows(ROW_NUMBER);
  };

  return (
    <div className={styles.agentsPage}>
      <h1>Агенты</h1>

      <div className={styles.cards}>
        {cardsData.map((data, index) => <BigCard key={index} {...data} />)}
      </div>
      
      <div className={styles.datatable}>
        <div className={styles.search}>
          <SearchBar onSearch={handleSearch}/>
        </div>
        
        <div className={styles.table}>
          <DataTable 
            value={agents.filter((agent) => 
                {
                  const nameMatch = agent.name.toLowerCase().includes(searchQuery.toLowerCase());
                  const agentIdMatch = agent.id.toString().includes(searchQuery);
                  return nameMatch || agentIdMatch;
                }
              )}
            className="datatable"
            emptyMessage='Нет агентов'
            paginator
            rows={rows}
            onSort={handleSort}
            sortField={sortField}
            sortOrder={sortOrder}
          >
            <Column field="date" header="Дата" sortable body={transformDate}/>
            <Column field="name" header="Фамилия Имя Отчество" sortable/>
            <Column field="id" header="ID агента" sortable/>
            <Column field="profit" header="Доход" sortable body={(data)=>`${formatCurrency(data.profit)} ₽`}/>
            <Column field="status" header="Статус" sortable/>
          </DataTable>
        </div>
      </div>
    </div>
  );
};
